document.querySelectorAll('.collection-category-filter-list-slider').forEach(el => {
    if (!el.classList.contains('swiper-initialized')) {
        const slides = el.querySelectorAll('.swiper-slide');
        let activeIndex = 0;

        slides.forEach((slide, index) => {
            if (slide.querySelector('a.active')) {
                activeIndex = index;
            }
        });

        new Swiper(el, {
            loop: false,
            grabCursor: false,
            spaceBetween: 40,
            slidesPerGroup: 1,
            slidesPerView: 6,
            initialSlide: activeIndex,
            watchSlidesProgress: true,
            draggable: !0,
            autoHeight: !1,
            watchOverflow: !0,
            threshold: 10,
            mousewheel: {
                forceToAxis: !0
            },
            observer: true,
            observeParents: true,
            freeMode: !0,
            scrollbar: {
                el: ".swiper-scrollbar"
            },
            breakpoints: {
                0: {
                    freeMode: !1,
                    spaceBetween: 8,
                    slidesPerView: "auto"
                },
                750: {
                    spaceBetween: 20,
                    slidesPerView: "auto"
                },
                990: {
                    spaceBetween: 20,
                    slidesPerView: "auto"
                },
                1440: {
                    spaceBetween: 40,
                    slidesPerView: 6
                }
            }
        })
    }
});